var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActGuidedImagery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 510 510",
    style: {
      enableBackground: "new 0 0 510 510"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9DD4E7;}\n\t.st1{fill:#FFE999;}\n\t.st2{fill:#9AEAB5;}\n\t.st3{fill:#BCF1CE;}\n\t.st4{fill:#FFD482;}\n\t.st5{fill:#FEFCF9;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255,30C130.7,30,30,130.7,30,255c0,8.9,0.5,17.7,1.5,26.3c0.4-0.1,51.1-10.1,120.4-5.8c0-0.4,0-0.7,0-1.1 c0-56.9,46.2-103.1,103.1-103.1c55.3,0,100.5,43.6,103,98.3c69.5-8.3,121.3,2.9,121.3,3c0.4-5.8,0.7-11.7,0.7-17.6 C480,130.7,379.3,30,255,30z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M270.8,290c-0.3-0.1-0.5-0.3-0.8-0.4c-0.1-0.1,5.2-2.4,6.6-2.7c0,0,0.6,0.1,1.8,0.4 c27.7-9.3,54.7-14.8,79.5-17.8c-2.5-54.7-47.7-98.3-103-98.3c-56.9,0-103.1,46.2-103.1,103.1c0,0.4,0,0.7,0,1.1 c33.1,2,70.4,7.3,108.5,18.4C263.9,292.6,267.4,291.3,270.8,290z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M176.6,341.4c-15.2-17.8-24.4-40.7-24.7-65.9c-69.3-4.3-119.9,5.7-120.4,5.8c6,51.6,29.5,98,64.4,132.8 c15.7-14.7,34.5-32.2,56.9-52.8C160.7,354.2,168.6,347.6,176.6,341.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M260.4,294c-38.1-11.1-75.4-16.4-108.5-18.4c0.3,25.1,9.5,48.1,24.7,65.9C203.9,320.4,232.3,305.1,260.4,294z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M358,269.6c0.1,1.6,0.1,3.2,0.1,4.9c0,16.4-3.9,32-10.7,45.8c13,9.4,26.2,21.3,38.4,36.2 c15.3,11.8,30,25.1,43.9,40.3c28-34.4,46-77.3,49.6-124.2C479.3,272.6,427.5,261.3,358,269.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M270.8,290c-3.5,1.3-6.9,2.6-10.4,3.9c13.3,3.9,26.7,8.5,40,13.9C291.5,301.5,281.7,295.5,270.8,290z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M347.4,320.3c6.9-13.8,10.7-29.3,10.7-45.8c0-1.6,0-3.2-0.1-4.9c-24.8,3-51.8,8.4-79.5,17.8 C286,289.2,315.8,297.3,347.4,320.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M385.8,356.5c12.1,14.9,23.1,32.7,31.6,54.2c4.3-4.5,8.4-9.1,12.3-13.9C415.8,381.6,401.1,368.2,385.8,356.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M255,377.6c-31.4,0-59.5-14-78.4-36.2c-8,6.1-15.9,12.8-23.7,19.9c-22.4,20.7-41.2,38.1-56.9,52.8 c40.7,40.7,96.9,65.8,159,65.8c48.6,0,93.6-15.4,130.4-41.6c-3.6-17.3-15.5-60-50.2-99.1C316.3,362.6,287.4,377.6,255,377.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M300.5,307.9c-13.3-5.4-26.7-10-40-13.9c-28.1,11.1-56.5,26.5-83.9,47.4c18.9,22.1,47,36.2,78.4,36.2 c32.4,0,61.3-15,80.2-38.4C325.5,328.3,314,317.6,300.5,307.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M276.7,287c-1.4,0.2-6.7,2.6-6.6,2.7c0.3,0.1,0.5,0.3,0.8,0.4c2.6-0.9,5.1-1.8,7.6-2.7 C277.3,287.1,276.7,287,276.7,287z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M385.8,356.5c-12.2-14.9-25.4-26.8-38.4-36.2c-1.4,2.7-2.8,5.4-4.4,8C357.6,336.4,371.9,345.8,385.8,356.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M270.8,290c10.8,5.4,20.7,11.5,29.6,17.9c14.3,5.8,28.5,12.5,42.5,20.4c1.6-2.6,3.1-5.3,4.4-8 c-31.6-22.9-61.4-31.1-68.9-32.9C275.9,288.2,273.4,289.1,270.8,290z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M343,328.3c-2.3,3.8-4.9,7.5-7.7,11c34.7,39.1,46.6,81.8,50.2,99.1c11.5-8.2,22.2-17.5,32-27.7 c-8.5-21.5-19.5-39.4-31.6-54.2C371.9,345.8,357.6,336.4,343,328.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M335.2,339.2c2.8-3.5,5.4-7.1,7.7-11c-14-7.8-28.2-14.6-42.5-20.4C314,317.6,325.5,328.3,335.2,339.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M431.1,182.4C431.1,182.4,431,182.4,431.1,182.4c0-0.7,0-1.3,0-2c0-17.3-15.9-31.3-35.5-31.3 c-13.6,0-25.4,6.7-31.4,16.7c-33.9-2.5-69.4,47.4-24.5,56.3c0,0,43.7,11.3,91.3,0C478.7,210.8,431.1,182.4,431.1,182.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M137.1,184.1C137.1,184.1,137.1,184.1,137.1,184.1c0-0.5,0-0.9,0-1.4c0-12.1-11.1-21.9-24.8-21.9 c-9.5,0-17.8,4.7-21.9,11.6c-23.7-1.7-48.5,33.1-17.1,39.4c0,0,30.5,7.9,63.9,0C170.4,204,137.1,184.1,137.1,184.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActGuidedImagery);
export default __webpack_public_path__ + "static/media/ActGuidedImagery.1c9619c7866d770a4b8200a47e81ec77.svg";
export { ForwardRef as ReactComponent };